import $ from 'jquery';

export default class Menu {
  constructor($el, states, initialState) {
    this.$el = $el;
    this.el = $el[0];
    this.states = states;
    this.currentState = initialState;
    this.$currentStateSlideout = $();
    this.$el.slideDown(() => {
      this.changeState(this.currentState);
    });
  }

  changeState(newState) {
    const $oldSlideout = $(this.currentState.slideoutSelector, this.$el);
    const $oldButtons = $(this.currentState.buttonsSelector, this.$el);
    const $newSlideout = $(newState.slideoutSelector, this.$el);
    const $newButtons = $(newState.buttonsSelector, this.$el);
    const callback = newState.callback;

    if (callback) {
      callback(this.currentState);
    }

    this._unbindEvents();
    this._unbindSlideoutEvents();
    this.currentState = newState;
    this.$currentStateSlideout = $newSlideout;
    this._bindEvents();

    if ($oldButtons.length) {
      $oldButtons.hide(0, () => $newButtons.show(0));
    } else {
      $newButtons.show(0);
    }

    if ($oldSlideout.length) {
      $oldSlideout.slideUp(() => $newSlideout.slideDown(() => {
        this._bindSlideoutEvents();
        $newSlideout.focus();
      }));
    } else {
      $newSlideout.slideDown(() => {
        this._bindSlideoutEvents();
        $newSlideout.focus();
      });
    }

    return true;
  }

  _bindEvents() {
    for (const button of this.currentState.buttons) {
      $(button.selector, this.$el).on('click.menu', () => button.callback());
    }
  }

  _unbindEvents() {
    for (const button of this.currentState.buttons) {
      $(button.selector, this.$el).off('click.menu');
    }
  }

  _bindSlideoutEvents() {
    if (!this.$currentStateSlideout.length) {
      return;
    }

    $(window).on('focusin.menu', (event) => {
      const $target = $(event.target);

      if (!this.$currentStateSlideout.length) {
        return;
      }

      if (
        !$.contains(this.$el[0], $target[0]) &&
        !$.contains(this.$currentStateSlideout[0], $target[0])
      ) {
        const dismiss = this.currentState.dismiss;

        if (dismiss) {
          dismiss(this.currentState);
        }
      }
    });

    $(window).on('touchstart.menu', () => this._minimizeSlideout());

    $(window).on('touchend.menu touchcancel.menu', () => {
      this._maximizeSlideout();
    });

    this.$el.on('touchstart.menu', (event) => {
      event.stopPropagation();
    });

    this.$el.on('touchend.menu, ', (event) => {
      event.stopPropagation();
    });
  }

  _unbindSlideoutEvents() {
    if (!this.$currentStateSlideout.length) {
      return;
    }

    $(window).off('focusin.menu');
    $(window).off('touchstart.menu');
    $(window).off('touchend.menu touchcancel.menu');
    this.$el.off('touchstart.menu');
    this.$el.off('touchend.menu');
  }

  _minimizeSlideout() {
    if (!this.$currentStateSlideout.length) {
      return;
    }

    const height = this.$currentStateSlideout[0].getBoundingClientRect().height;
    this.$currentStateSlideout.animate({ height: height / 2, opacity: 0.2 }, { queue: false, duration: 500 });
  }

  _maximizeSlideout() {
    if (!this.$currentStateSlideout.length) {
      return;
    }

    const oldHeight = this.$currentStateSlideout[0].getBoundingClientRect().height;
    this.$currentStateSlideout.css('height', '');

    const height = this.$currentStateSlideout[0].getBoundingClientRect().height;
    this.$currentStateSlideout.css('height', oldHeight);

    this.$currentStateSlideout.animate({ height: height, opacity: 1 }, { queue: false, duration: 500 });
  }

  minimizeMenu() {
    this.el.classList.add('menu-minimized');
  }

  maximizeMenu() {
    this.el.classList.remove('menu-minimized');
  }

  unload() {
    this._unbindEvents();
    this._unbindSlideoutEvents();
  }
}
